import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MaterialModule } from 'src/app/material.module';
import { CommonModule } from '@angular/common';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { TablerIconsModule } from 'angular-tabler-icons';

@Component({
  selector: 'app-confirm-dialog',
  standalone: true,
  imports: [MaterialModule, CommonModule, MatDialogModule, TablerIconsModule],
  template: `
    <div class="confirm-dialog-container">
      <div class="d-flex align-items-center justify-content-between p-x-24 p-t-20 p-b-16">
        <h3 class="m-0">{{ data.title }}</h3>
        <button mat-icon-button (click)="onCancel()" class="d-flex justify-content-center">
          <i-tabler name="x" class="icon-20 d-flex"></i-tabler>
        </button>
      </div>

      <mat-dialog-content class="p-x-24 p-b-16">
        <p *ngIf="!data.content" class="m-t-0" [innerHTML]="data.message"></p>
        <div *ngIf="data.content" [innerHTML]="safeHtml"></div>
      </mat-dialog-content>

      <mat-dialog-actions class="p-x-24 p-b-20 p-t-8">
        <div class="d-flex justify-content-end w-100">
          <button
            *ngIf="data.cancelText"
            mat-stroked-button
            (click)="onCancel()"
          >
            {{ data.cancelText }}
          </button>
          <button
            *ngIf="data.extraText"
            mat-stroked-button
            [color]="data.extraColor || 'warn'"
            class="m-l-8"
            (click)="onExtra()"
          >
            {{ data.extraText }}
          </button>
          <button
            mat-flat-button
            [color]="data.confirmColor || 'warn'"
            class="m-l-8"
            (click)="onConfirm()"
          >
            {{ data.confirmText || 'Aceptar' }}
          </button>
        </div>
      </mat-dialog-actions>
    </div>
  `,
  styles: [`
    .confirm-dialog-container {
      min-width: 400px;
    }

    mat-dialog-content {
      line-height: 1.6;
    }

    mat-dialog-content p {
      margin-bottom: 0;
    }

    mat-dialog-actions {
      margin: 0;
      padding: 0;
    }
  `]
})
export class ConfirmDialogComponent {
  safeHtml: SafeHtml;

  constructor(
    public dialogRef: MatDialogRef<ConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      title: string;
      message?: string;
      content?: string;
      confirmText?: string;
      extraText?: string;
      cancelText?: string;
      confirmColor?: string;
      extraColor?: string;
    },
    private sanitizer: DomSanitizer
  ) {
    // Sanitizar el contenido HTML para mostrarlo de forma segura
    this.safeHtml = data.content ? this.sanitizer.bypassSecurityTrustHtml(data.content) : '';
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }

  onExtra(): void {
    this.dialogRef.close('discard');
  }
}
